module.exports = [{"id":"1","lang":"官方战区"},{"id":"2","lang":"渠道战区"},{"id":"3","lang":"海外互通战区"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/server_pattern_option.json
// module id = HHqy
// module chunks = 1